module.exports = __webpack_public_path__ + "img/logo-akib.a1feea22.svg";